import * as actions from './actions';
import * as schoolRollActions from '../school-roll/actions';
import * as quickUploadActions from '../quick-upload/actions';
import * as teacherRollActions from '../teacher-roll/actions';
import * as assignUserActions from '../assign-user/actions';
import * as editStudentActions from '../edit-student/actions';
import * as editTeacherActions from '../edit-teacher/actions';
import * as classRollActions from '../class-roll/actions';

import messages from './messages';
import { getAlphaNumericCharacters, updateYearGroups, updateClassroomList } from '../../helpers/utils';
import { filterStudents, sort } from '../../helpers/grid-util';

const getStudentLastNames = () => {
    const names = [{ key: '-1', value: messages.defaultOptionStudentLastName, selected: true }];
    const namePrefixes = getAlphaNumericCharacters().split('').map(item => ({ key: item, value: item }));
    const allNamePrefixes = names.concat(namePrefixes);
    return allNamePrefixes;
};

const dataFilterOption = {
    yearGroups: [{ key: '-1', value: messages.defaultOptionStudentYearGroup, selected: true }],
    lastNames: getStudentLastNames(),
    classrooms: [{ key: 'assignedStudents', value: messages.assignedStudents, selected: true },
        { key: '-1', value: messages.defaultOptionStudentClass, selected: false },
        { key: 'classes', value: messages.UnassignedStudent, selected: false }],
    searchTerm: '',
    sortColumn: 'lastName',
    sortDirection: 'asc'
};

const assignEmptyStudentObject = () => (
    { firstName: '', lastName: '', yearGroup: '-1', classroomId: '-1', previousUsername: '' }
);

const initState = {
    students: [],
    filteredStudents: [],
    isStudentDataLoaded: false,
    dataFilterOption,
    selectedStudents: [],
    isSaveInProgress: false,
    studentModel: assignEmptyStudentObject(),
    deletedStudentsCount: 0,
    isPartialDelete: false,
    lastAddedStudentUserProfileId: 0,
    isSignInCardDownloaded: true,
    isUserOperationModalOpen: false,
    isUnassignedModalOpen: false,
    unassignDisableButton: false,
    isBulkPasswordChangeModalOpen: false,
    bulkPasswordChangeDisableButton: false,
    bulkPasswordValue: '',
    refreshStudentList: false,
    disableConfirmationButton: false,
    isDeleteUserModalOpen: false,
    operationType: '',
    showHideSignInCardModal: false
};

const resetSelectedItem = (items) => {
    let selectedItem = items.find(item => item.selected === true);
    selectedItem = selectedItem === undefined ? {} : selectedItem;
    selectedItem.selected = false;
    items[0].selected = true;
    return items;
};

const resetFilterOptions = (currentOptions) => {
    const yearGroups = resetSelectedItem(currentOptions.yearGroups);
    const lastNames = resetSelectedItem(currentOptions.lastNames);
    const classrooms = resetSelectedItem(currentOptions.classrooms);
    return { ...currentOptions, yearGroups, lastNames, classrooms, searchTerm: currentOptions.searchTerm };
};

const getFilteredData = (students, filterOptions) => filterStudents(students, filterOptions);

const getSortedData = (students, filterOptions) => sort(
    students,
    filterOptions.sortColumn,
    filterOptions.sortDirection);

const changeFilterOptions = (currentOptions, collectionName, key) => {
    const items = currentOptions[collectionName];
    const selectedItem = items.find(item => item.selected === true);
    selectedItem.selected = false;
    const newSelection = items.find(item => item.key.toString() === key);
    newSelection.selected = true;
    return { ...currentOptions, [collectionName]: currentOptions[collectionName] };
};

export default function (state = initState, action) {
    switch (action.type) {
    case actions.GET_PRODUCT_STUDENTS_REQUEST: {
        return { ...state, isStudentDataLoaded: false, students: [], filteredStudents: [] };
    }
    case actions.GET_PRODUCT_STUDENTS_SUCCESS: {
        state.dataFilterOption.searchTerm = '';
        return {
            ...state,
            isStudentDataLoaded: true,
            refreshStudentList: false,
            students: action.data,
            filteredStudents: getFilteredData(action.data, resetFilterOptions(state.dataFilterOption)),
            studentsCount: action.data.length,
            dataFilterOption: resetFilterOptions(state.dataFilterOption)
        };
    }
    case actions.DOWNLOAD_STUDENT_ROLL_REQUEST: {
        return { ...state, isStudentRollDownloaded: action.isStudentRollDownloaded };
    }
    case actions.DOWNLOAD_STUDENT_ROLL_SUCCESS: {
        return { ...state, isStudentRollDownloaded: action.isStudentRollDownloaded };
    }
    case actions.FILTER_VALUE_CLEARED: {
        const filterOption = resetFilterOptions(state.dataFilterOption);
        const filteredStudents = getFilteredData(state.students, filterOption);
        return { ...state, filteredStudents, dataFilterOption: filterOption, selectedStudents: [] };
    }
    case actions.FILTER_VALUE_CHANGED: {
        const filterOption = changeFilterOptions(state.dataFilterOption, action.collectionName, action.key);
        const filteredStudents = getFilteredData(state.students, filterOption);
        return { ...state, filteredStudents, dataFilterOption: filterOption, selectedStudents: [] };
    }
    case actions.UPDATE_SEARCH_TERM: {
        const filterOption = { ...state.dataFilterOption, searchTerm: action.searchTerm };
        const filteredStudents = getFilteredData(state.students, filterOption);
        return { ...state, filteredStudents, dataFilterOption: filterOption, selectedStudents: [] };
    }
    case actions.SORT_STUDENT_LIST: {
        let sortDirection = 'asc';
        if (state.dataFilterOption.sortColumn === action.columnToSort) {
            if (state.dataFilterOption.sortDirection === 'asc') {
                sortDirection = 'desc';
            }
        }

        const filterOption = { ...state.dataFilterOption, sortColumn: action.columnToSort, sortDirection };
        const filteredStudents = getSortedData(state.filteredStudents, filterOption);
        return { ...state, filteredStudents, dataFilterOption: filterOption };
    }
    case actions.RETRIEVE_SELECTED_STUDENT: {
        return { ...state, selectedStudents: action.selectedStudents };
    }
    case actions.UNASSIGN_STUDENTS_REQUEST: {
        return { ...state, disableConfirmationButton: action.disableConfirmationButton };
    }
    case actions.UNASSIGN_STUDENTS_SUCCESS: {
        const filterOption = { ...state.dataFilterOption, searchTerm: action.searchTerm };
        const filteredStudents = getFilteredData(state.students, filterOption);
        return {
            ...state,
            isUserOperationModalOpen: action.isUserOperationModalOpen,
            disableConfirmationButton: action.disableConfirmationButton,
            filteredStudents
        };
    }
    case actions.UNASSIGN_STUDENTS_FAILURE: {
        return { ...state, disableConfirmationButton: action.disableConfirmationButton };
    }
    case actions.OPEN_UNASSIGN_STUDENTS_MODAL: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType };
    }
    case actions.CLOSE_STUDENTS_OPERATION_CONFIRMATION_MODAL: {
        return { ...state, refreshStudentList: action.refreshStudentList, selectedStudents: action.selectedStudents, operationType: action.operationType };
    }
    case actions.ADD_STUDENT_OPEN_MODAL_REQUEST: {
        return { ...state, showModal: action.showModal, studentModel: assignEmptyStudentObject(), showAddStudentConfirmationModal: action.showAddStudentConfirmationModal, lastAddedStudentUserProfileId: 0 };
    }
    case actions.ADD_ANOTHER_STUDENT_OPEN_MODAL_REQUEST: {
        return { ...state, showModal: action.showModal, studentModel: assignEmptyStudentObject(), showAddStudentConfirmationModal: action.showAddStudentConfirmationModal };
    }
    case actions.ADD_STUDENT_CLOSE_MODAL_REQUEST:
    {
        return {
            ...state,
            showModal: action.showModal
        };
    }
    case actions.ADD_STUDENT_REQUEST:
    {
        return { ...state, isSaveInProgress: action.isSaveInProgress };
    }
    case actions.ADD_STUDENT_SUCCESS:
    {
        return {
            ...state,
            isSaveInProgress: false,
            studentModel: assignEmptyStudentObject(),
            showAddStudentConfirmationModal: action.showAddStudentConfirmationModal,
            lastAddedStudentUserProfileId: action.userProfileId,
            selectedStudents: []
        };
    }
    case actions.ADD_STUDENT_FAILURE:
    {
        let errorMessage = '';
        if (action.isServerError) {
            errorMessage = messages.errorMessageHeader;
        } else {
            errorMessage = action.addStudentValidationMessage;
        }
        return { ...state, isSaveInProgress: false, showAddStudentValidationModal: action.showAddStudentValidationModal, addStudentValidationMessage: errorMessage };
    }
    case actions.ADD_STUDENT_GET_GROUPS_REQUEST:
    {
        return { ...state, isFetchingGroupsAddStudent: true, fetchedGroupsAddStudent: false };
    }
    case actions.ADD_STUDENT_GET_GROUPS_SUCCESS:
    {
        return { ...state, classroomGroups: action.classroomGroups, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: true };
    }
    case actions.ADD_STUDENT_GET_GROUPS_FAILURE:
    {
        return { ...state, isFetchingGroupsAddStudent: false, fetchedGroupsAddStudent: false };
    }
    case actions.CLOSE_ADD_STUDENT_VALIDATION_MODAL:
    {
        return { ...state, showAddStudentValidationModal: action.showAddStudentValidationModal };
    }
    case actions.PRINT_SIGN_IN_CARD_REQUEST: {
        return { ...state, isSignInCardDownloaded: action.isSignInCardDownloaded };
    }
    case actions.PRINT_SIGN_IN_CARD_SUCCESS: {
        return { ...state, isSignInCardDownloaded: action.isSignInCardDownloaded };
    }
    case actions.PRINT_SIGN_IN_CARD_FAILURE: {
        return { ...state, isSignInCardDownloaded: action.isSignInCardDownloaded };
    }
    case actions.BULK_PASSWORD_CHANGE_STUDENTS_REQUEST: {
        return { ...state, disableConfirmationButton: action.disableConfirmationButton };
    }
    case actions.BULK_PASSWORD_CHANGE_STUDENTS_SET_VALUE: {
        return { ...state, bulkPasswordValue: action.bulkPasswordValue };
    }
    case actions.BULK_PASSWORD_CHANGE_STUDENTS_SUCCESS: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, disableConfirmationButton: false };
    }
    case actions.BULK_PASSWORD_CHANGE_STUDENTS_FAILURE: {
        return { ...state, bulkPasswordChangeDisableButton: action.bulkPasswordChangeDisableButton, disableConfirmationButton: false };
    }
    case actions.OPEN_BULK_PASSWORD_CHANGE_STUDENTS_MODAL: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, disableConfirmationButton: false, bulkPasswordValue: '', operationType: action.operationType };
    }
    case actions.OPEN_DELETE_USER_MODAL: {
        return { ...state, isUserOperationModalOpen: action.isUserOperationModalOpen, operationType: action.operationType };
    }
    case actions.DELETE_STUDENT_REQUEST: {
        return { ...state, disableConfirmationButton: action.disableConfirmationButton, operationType: action.operationType };
    }
    case actions.DELETE_STUDENT_SUCCESS: {
        return { ...state,
            disableConfirmationButton: action.disableConfirmationButton,
            isUserOperationModalOpen: action.isUserOperationModalOpen,
            deletedStudentsCount: action.deletedStudentsCount,
            isPartialDelete: action.isPartialDelete,
            refreshStudentList: action.deletedStudentsCount > 0,
            selectedStudents: action.selectedStudents
        };
    }
    case actions.DELETE_STUDENT_FAILURE: {
        return { ...state, disableConfirmationButton: action.disableConfirmationButton };
    }

    case schoolRollActions.GET_YEAR_GROUPS_SUCCESS: {
        return { ...state, dataFilterOption: updateYearGroups(state.dataFilterOption, action.data) };
    }

    case classRollActions.GET_CLASSROOMS_SUCCESS: {
        return {
            ...state,
            dataFilterOption: updateClassroomList(resetFilterOptions(state.dataFilterOption), action.data),
            filteredStudents: getFilteredData(state.students, updateClassroomList(state.dataFilterOption, action.data))
        };
    }

    case quickUploadActions.QUICK_UPLOAD_CLOSE_MODAL_REQUEST:
    case assignUserActions.CANCEL_USER_ASSIGN_REQUEST:
    {
        return { ...state, isStudentDataLoaded: false, selectedStudents: [] };
    }

    case assignUserActions.RESET_USER_CLASSROOM_RELATION: {
        return { ...state, selectedStudents: [] };
    }

    case editStudentActions.EDIT_STUDENT_SUCCESS_REQUEST: {
        return { ...state, refreshStudentList: true, selectedStudents: [] };
    }

    case actions.CLEAR_OPERATION_TYPE: {
        return { ...state, operationType: '' };
    }

    case classRollActions.DELETE_CLASSROOMS_SUCCESS:
    case assignUserActions.ASSIGN_STUDENT_SUCCESS:
    case assignUserActions.ASSIGN_TEACHER_SUCCESS:
    case teacherRollActions.DELETE_TEACHER_SUCCESS:
    case teacherRollActions.UNASSIGN_TEACHERS_SUCCESS:
    case editTeacherActions.EDIT_TEACHER_SUCCESS_REQUEST:
    case editTeacherActions.UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS:
    case editStudentActions.REFRESH_STUDENT_LIST_ON_CANCEL_REQUEST:
    case assignUserActions.ASSIGN_TEACHER_TO_CLASSROOM_SUCCESS: {
        return { ...state, refreshStudentList: action.refreshStudentList, isStudentDataLoaded: false, selectedStudents: [] };
    }

    case actions.DOWNLOAD_STUDENTS_SIGN_IN_CARD: {
        return { ...state, operationType: action.operationType, isUserOperationModalOpen: action.isUserOperationModalOpen };
    }

    case actions.SHOW_HIDE_SIGNIN_CARD_MODAL: {
        return { ...state, showHideSignInCardModal: action.showHideSignInCardModal };
    }
    default:
        return { ...state };
    }
}



// WEBPACK FOOTER //
// ./app/containers/student-roll/reducer.js